import { InjectionToken } from '@angular/core';

export const SHARED_GATEWAY_CONFIG = new InjectionToken<GatewayConfig>(
  'SHARED_GATEWAY_CONFIG',
);

export interface GatewayConfig {
  cdn: string;
  communicationPreferencesUrl: string;
  directory: string;
  directoryGeolocation: string;
  directoryTypeahead: string;
  eirAnalytics: string;
  elevateSurvey: string;
  gsg: string;
  launchDarkly: string;
  publicLinkRouter: string;
  resourceContent: string;
  privateLinkRouter: string;
}

export enum ApiVersion {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
}
